import Container from '@v2/shared/components/Container';
import backIssuesImage from './images/backissues.png';

export default function BackIssuesPanel() {
  return (
    <div className="grid justify-center bg-black">
      <Container className="grid grid-cols-1 lg:grid-cols-2 py-12 md:py-20 lg:py-20 xl:py-28">
        <span className="flex justify-center items-start flex-col lg:pr-20 xl:pr-16">
          <h2 className="text-yellow-400 text-4xl md:text-4xl lg:text-3xl xl:text-5xl mb-5 lg:mb-10 font-bold max-w-xl">
            Access back issues you might&apos;ve missed
          </h2>
          <p className="text-slate-200 text-md md:text-md lg:text-lg xl:text-xl font-semibold mb-8 lg:mb-0">
            With Magzter Gold, you have access to back issues, allowing you to go back in time and read your favorites
            before you knew they were your favorites.
          </p>
        </span>
        <span className="w-full h-full flex items-center justify-center pt-0 sm:pt-4 md:pt-10 lg:pt-0">
          <img src={backIssuesImage} className="object-cover" alt="Back issues timeline" />
        </span>
      </Container>
    </div>
  );
}
